"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIcon = getIcon;
exports.getIconAsync = void 0;
exports.getUxIcon = getUxIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _cart = _interopRequireDefault(require("@ux/icon/cart"));
var _checkmark = _interopRequireDefault(require("@ux/icon/checkmark"));
var _trash = _interopRequireDefault(require("@ux/icon/trash"));
var _linkArrow = _interopRequireDefault(require("@ux/icon/link-arrow"));
var _website = _interopRequireDefault(require("@ux/icon/website"));
var _shield = _interopRequireDefault(require("@ux/icon/shield"));
var _circle = _interopRequireDefault(require("@ux/icon/circle"));
var _creditCard = _interopRequireDefault(require("@ux/icon/credit-card"));
var _delete = _interopRequireDefault(require("@ux/icon/delete"));
var _exchange = _interopRequireDefault(require("@ux/icon/exchange"));
var _filter = _interopRequireDefault(require("@ux/icon/filter"));
var _dollar = _interopRequireDefault(require("@ux/icon/dollar"));
var _mail = _interopRequireDefault(require("@ux/icon/mail"));
var _lightbulb = _interopRequireDefault(require("@ux/icon/lightbulb"));
var _diamond = _interopRequireDefault(require("@ux/icon/diamond"));
var _ok = _interopRequireDefault(require("@ux/icon/ok"));
var _wand = _interopRequireDefault(require("@ux/icon/wand"));
var _heartFilled = _interopRequireDefault(require("@ux/icon/heart-filled"));
var _history = _interopRequireDefault(require("@ux/icon/history"));
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
var _sparkles = _interopRequireDefault(require("@ux/icon/sparkles"));
var _clock = _interopRequireDefault(require("@ux/icon/clock"));
var _graph = _interopRequireDefault(require("@ux/icon/graph"));
var _resize = _interopRequireDefault(require("@ux/icon/resize"));
var _search = _interopRequireDefault(require("@ux/icon/search"));
var _gdTheGo = _interopRequireDefault(require("@ux/icon/gd-the-go"));
var _world = _interopRequireDefault(require("@ux/icon/world"));
var _apps = _interopRequireDefault(require("@ux/icon/apps2"));
var _shieldCheck = _interopRequireDefault(require("@ux/icon/shield-check"));
var _alert = _interopRequireDefault(require("@ux/icon/alert"));
var _arrowRight = _interopRequireDefault(require("@ux/icon/arrow-right"));
var _fire = _interopRequireDefault(require("@ux/icon/fire"));
var _asyncIcon = _interopRequireDefault(require("@ux/icon/async-icon.js"));
function getUxIcon(icon) {
  switch (icon) {
    case 'cart':
      return _cart.default;
    case 'checkmark':
      return _checkmark.default;
    case 'alert':
      return _alert.default;
    case 'arrow':
      return _linkArrow.default;
    case 'trash':
      return _trash.default;
    case 'website':
      return _website.default;
    case 'shield':
      return _shield.default;
    case 'circle':
      return _circle.default;
    case 'creditcard':
      return _creditCard.default;
    case 'delete':
      return _delete.default;
    case 'exchange':
      return _exchange.default;
    case 'filter':
      return _filter.default;
    case 'dollar':
      return _dollar.default;
    case 'mail':
      return _mail.default;
    case 'lightbulb':
      return _lightbulb.default;
    case 'diamond':
      return _diamond.default;
    case 'ok':
      return _ok.default;
    case 'wand':
      return _wand.default;
    case 'heart-filled':
      return _heartFilled.default;
    case 'history':
      return _history.default;
    case 'sparkles':
      return _sparkles.default;
    case 'clock':
      return _clock.default;
    case 'graph':
      return _graph.default;
    case 'resize':
      return _resize.default;
    case 'gd-the-go':
      return _gdTheGo.default;
    case 'sparkles-filled':
      return _sparklesFilled.default;
    case 'world':
      return _world.default;
    case 'apps2':
      return _apps.default;
    case 'shield-check':
      return _shieldCheck.default;
    case 'search':
      return _search.default;
    case 'arrow-right':
      return _arrowRight.default;
    case 'fire':
      return _fire.default;
    default:
      return null;
  }
}
function getIcon({
  icon,
  iconSize,
  className = '',
  dataCy,
  ...props
}) {
  const commonProps = {
    ...(dataCy && {
      'data-cy': `${dataCy}-${icon}-icon`
    }),
    height: iconSize,
    width: iconSize,
    className,
    ...props
  };
  const Icon = getUxIcon(icon);
  return Icon ? /*#__PURE__*/_react.default.createElement(Icon, commonProps) : null;
}
const getIconAsync = ({
  icon,
  iconSize,
  fill,
  className = '',
  dataCy,
  ...props
}) => {
  const iconProps = {
    ...(dataCy && {
      'data-cy': `${dataCy}-${icon}-icon`
    }),
    height: iconSize,
    width: iconSize,
    className,
    fill,
    'data-testid': `${icon}`,
    ...props
  };
  return icon ? /*#__PURE__*/_react.default.createElement(_asyncIcon.default, (0, _extends2.default)({
    icon: `${icon}`
  }, iconProps)) : null;
};
exports.getIconAsync = getIconAsync;